<template>
  <div>
    <main class="actions">
        <h5 style="text-align: center">{{banMessage}}</h5>
    </main>
  </div>
</template>
<script>
import iconLogout from "./../assets/svg/fnz_logout.svg";
import _ from 'lodash'
export default {
  name: "banned",
  data: function() {
    return {
      banMessage: null
    };
  },
  mounted() {
      if(this.$store.state.user.banned) {
        this.getBannedMessage();
      } else {
          this.$router.replace('/dashboard');
      }
  },
  methods: {
    async getBannedMessage() {
     this.$store.commit("showSpinner");
      let response = await this.$http.get(
        "api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/users/ban/message"
      );

      this.banMessage = _.get(response, 'data.data.message', '');
      this.$store.commit("hideSpinner");
    }
  },
  components: {
    iconLogout
  }
};
</script>